//
//
//
//
//
//

const bgClasses = {
  dark: 'bg-blue-900',
  medium: 'bg-blue-500',
  light: 'bg-blue-200',
  tint: 'bg-blue-100',
  transparent: 'bg-transparent',
  white: 'bg-white',
  intervene: 'bg-spr-intervene',
  watch: 'bg-spr-watch',
  reinforce: 'bg-spr-reinforce',
  model: 'bg-spr-model',
  gray: 'bg-gray-300'
}
const textClasses = {
  dark: 'text-white',
  medium: 'text-white',
  light: 'text-blue-800',
  tint: 'text-blue-800',
  transparent: 'text-blue-800',
  white: 'text-blue-800',
  intervene: 'text-white',
  watch: 'text-white',
  reinforce: 'text-white',
  model: 'text-white',
  red: 'text-spr-intervene'
}
const alignClasses = {
  center: 'text-center'
}

export default {
  props: {
    // optional
    color: {
      type: String,
      required: false,
      default: 'transparent'
    },
    align: {
      type: String,
      required: false,
      default: 'center'
    },
    tight: {
      type: Boolean,
      required: false,
      default: false
    },
    noPadding: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    bgClass() {
      return bgClasses[this.color]
    },
    textClass() {
      return textClasses[this.color]
    },
    alignClass() {
      return alignClasses[this.align]
    },
    pClass() {
      return this.noPadding ? '' : this.tight ? 'p-1' : 'p-6'
    }
  }
}
